<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Clock Time'" style="height: 100%">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <!--显示-->
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th
                v-for="(value, key) in clockTime.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in clockTime.data"
              :key="row.weekday"
              :class="{ 'true:': true }"
            >
              <td>
                <div>{{ row.weekday }}</div>
              </td>
              <td>
                <div>{{ row.date }}</div>
              </td>
              <td>
                <div>{{ row.time }}</div>
              </td>
              <td>
                <div>{{ row.timezoneName }}</div>
              </td>
              <td>
                <div>{{ row.timezoneOffset }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <!--配置-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Clock Time Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-4 control-label" for="date">Date</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('date', clockTimeForm.date),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="date"
                    v-model="clockTimeForm.date"
                    placeholder="YYYY/MM/DD"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('date', clockTimeForm.date)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("date", clockTimeForm.date) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label" for="time">Time</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('time', clockTimeForm.time),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="time"
                    v-model="clockTimeForm.time"
                    placeholder="HH:MM:SS"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('time', clockTimeForm.time)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("time", clockTimeForm.time) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label" for="name"
                  >Timezone Name</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'timezoneName',
                      clockTimeForm.timezoneName
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    v-model="clockTimeForm.timezoneName"
                    placeholder="STRING<1-32>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'timezoneName',
                        clockTimeForm.timezoneName
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters(
                        "timezoneName",
                        clockTimeForm.timezoneName
                      )
                    }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label" for="offsetHours"
                  >Timezone Offset Hours</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'offsetHours',
                      clockTimeForm.offsetHours
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="offsetHours"
                    v-model="clockTimeForm.offsetHours"
                    placeholder="STRING<1-3> (range -23 to 23)"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'offsetHours',
                        clockTimeForm.offsetHours
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("offsetHours", clockTimeForm.offsetHours)
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label" for="offsetMinutes"
                  >Timezone Offset Minutes</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'offsetMinutes',
                      clockTimeForm.offsetMinutes
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="offsetMinutes"
                    v-model="clockTimeForm.offsetMinutes"
                    placeholder="INTEGER<0-59>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'offsetMinutes',
                        clockTimeForm.offsetMinutes
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters(
                        "offsetMinutes",
                        clockTimeForm.offsetMinutes
                      )
                    }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  data() {
    return {
      isShowAddTable: false,
      iBox: {},
      clockTime: "",
      clockTimeForm: {
        date: "",
        time: "",
        timezoneName: "",
        offsetHours: "",
        offsetMinutes: "",
      },
    }
  },
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  created() {
    this.loadSystemTime()
  },
  methods: {
    /*获取时钟信息*/
    loadSystemTime() {
      get("clockTime")
        .then((res) => {
          this.clockTime = res.data
        })
        .catch((err) => {})
    },

    clkEdit() {
      var timeOffset = this.clockTime.data[0].timezoneOffset
      var str = ""
      var str1 = ""

      for (let i = 0; i < timeOffset.length; i++) {
        if (timeOffset[i] == ":") {
          for (let j = i + 1; j < timeOffset.length; j++) {
            str1 += timeOffset[j]
          }
          break
        }
        str += timeOffset[i]
      }

      this.clockTimeForm.date = this.clockTime.data[0].date
      this.clockTimeForm.time = this.clockTime.data[0].time
      this.clockTimeForm.timezoneName = this.clockTime.data[0].timezoneName
      this.clockTimeForm.offsetHours = Number(str)
      this.clockTimeForm.offsetMinutes = Number(str1)
      this.isShowAddTable = true
      return
    },

    /*配置*/
    clkApply() {
      var clockTimeConfig = {
        date: this.clockTimeForm.date,
        time: this.clockTimeForm.time,
        timezoneName: this.clockTimeForm.timezoneName,
        offsetHours: Number(this.clockTimeForm.offsetHours),
        offsetMinutes: Number(this.clockTimeForm.offsetMinutes),
      }

      if (
        this.clockTimeForm.date == "" ||
        this.clockTimeForm.time == "" ||
        this.clockTimeForm.timezoneName == "" ||
        this.clockTimeForm.offsetHours === "" ||
        this.clockTimeForm.offsetMinutes === "" ||
        this.checkParameters("date", this.clockTimeForm.date) ||
        this.checkParameters("time", this.clockTimeForm.time) ||
        this.checkParameters("timezoneName", this.clockTimeForm.timezoneName) ||
        this.checkParameters("offsetHours", this.clockTimeForm.offsetHours) ||
        this.checkParameters("offsetMinutes", this.clockTimeForm.offsetMinutes)
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("clockTime", clockTimeConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSystemTime()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    clkCancel() {
      this.isShowAddTable = false
    },

    /* 输入参数检测 */
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "date") {
        if (value.match(/^\d{4}\/\d{1,2}\/\d{1,2}$/) == null) {
          return "YYYY/MM/DD"
        }
      } else if (type == "time") {
        if (value.match(/^\d{1,2}\:\d{1,2}\:\d{1,2}$/) == null) {
          return "HH:MM:SS"
        }
      } else if (type == "timezoneName") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 32
        ) {
          return "invalid timezone name"
        }
      } else if (type == "offsetHours") {
        if (isNaN(Number(value)) || Number(value) < -23 || Number(value) > 23) {
          return "invalid offset hours(range -23 to 23)."
        }
      } else if (type == "offsetMinutes") {
        if (isNaN(Number(value)) || Number(value) < 0 || Number(value) > 59) {
          return "invalid offset minutes(range 0 to 59)."
        }
      }

      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>